import { ASSET_TAXONOMY_FILTER_ALL } from './constants/asset-taxonomies';

const FILTER_ALL_NORMALIZED = ASSET_TAXONOMY_FILTER_ALL.toLowerCase();

function normalizeComparableString(value: string): string {
  return value.trim().toLowerCase();
}

export function isTaxonomyFilterAll(value: string): boolean {
  return normalizeComparableString(value) === FILTER_ALL_NORMALIZED;
}

/** Strips All/blank values; empty means no filter on this dimension. */
export function normalizeTaxonomyFilterValues(
  values: readonly string[] | null | undefined,
): string[] {
  if (!values?.length) {
    return [];
  }

  return [
    ...new Set(
      values
        .map((value) => value.trim())
        .filter((value) => value.length > 0 && !isTaxonomyFilterAll(value)),
    ),
  ];
}

function normalizedTaxonomyKeySet(values: readonly string[] | null | undefined): Set<string> {
  return new Set(normalizeTaxonomyFilterValues(values).map(normalizeComparableString));
}

export function taxonomyValuesOverlap(
  left: readonly string[] | null | undefined,
  right: readonly string[] | null | undefined,
): boolean {
  const leftKeys = normalizedTaxonomyKeySet(left);
  const rightKeys = normalizedTaxonomyKeySet(right);
  if (leftKeys.size === 0 || rightKeys.size === 0) {
    return true;
  }

  for (const key of leftKeys) {
    if (rightKeys.has(key)) {
      return true;
    }
  }
  return false;
}
